import React from 'react';
import { steps } from '../data/content';
import './HowToUse.css';

export default function HowToUse() {
  return (
    <section className="how-section" id="how-to-use">
      <div className="how-grid">
        {/* Steps */}
        <div>
          <span className="section-eyebrow">Simple Daily Ritual</span>
          <h2 className="section-title">How to Take<br />Your Daily Dose</h2>

          <ul className="steps-list">
            {steps.map((step) => (
              <li className="step-item" key={step.num}>
                <div className="step-num">{step.num}</div>
                <div className="step-text">
                  <strong>{step.title}</strong>
                  <p>{step.desc}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        {/* Visual Card */}
        <div className="how-visual">
          <span className="big-emoji">🫗</span>
          <h3 className="how-visual-title">Daily Ritual</h3>
          <p className="how-visual-desc">
            Consistency is key. Most users notice positive changes within 3–4 weeks
            of regular use alongside a balanced diet.
          </p>
          <div className="dosage-box">
            <div className="dosage-label">Recommended Serving</div>
            <div className="dosage-amount">1 tsp</div>
            <div className="dosage-unit">= 5g · Twice daily</div>
          </div>
        </div>
      </div>
    </section>
  );
}
